<template>
  <v-container>
    <h2 class="mb-4">メンテナンスモード管理</h2>

    <v-card class="mb-4 pa-4">
      <div class="d-flex align-center">
        <div class="mr-4">現在のあなたのIP:</div>
        <strong>{{ currentIp || '取得中...' }}</strong>
      </div>
      <v-btn small class="mt-2" @click="addCurrentIp" v-if="currentIp">
        このIPを許可リストに追加する
      </v-btn>
    </v-card>

    <v-card class="mb-4 pa-4">
      <div class="d-flex align-center">
        <v-switch
          v-model="enabled"
          label="メンテナンスモード"
          @change="onToggleMaintenance"
        />
        <span class="ml-4" v-if="enabled" style="color:#c00;font-weight:bold">
          ONです — 許可IP以外はアクセスできません
        </span>
      </div>
    </v-card>

    <v-card class="pa-4">
      <h3 class="mb-3">許可IPリスト</h3>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>IP / CIDR</th>
              <th>ラベル</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ip in allowedIps" :key="ip.id">
              <td>{{ ip.ip_address }}</td>
              <td>{{ ip.label }}</td>
              <td>
                <v-btn small color="error" @click="removeIp(ip.id)">削除</v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-row class="mt-4">
        <v-col cols="5">
          <v-text-field v-model="newIp.ip_address" label="IP または CIDR (例: 203.0.113.1 / 192.168.1.0/24)" />
        </v-col>
        <v-col cols="5">
          <v-text-field v-model="newIp.label" label="ラベル (例: 本社オフィス)" />
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <v-btn color="primary" @click="createIp">追加</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'Maintenance',
  data() {
    return {
      enabled: false,
      allowedIps: [],
      newIp: { ip_address: '', label: '' },
      currentIp: '',
    }
  },
  async mounted() {
    await this.loadAll()
  },
  methods: {
    async loadAll() {
      const [setting, ips, whoami] = await Promise.all([
        this.$axios.get('/api/v1/admin/maintenance'),
        this.$axios.get('/api/v1/admin/maintenance_allowed_ips'),
        this.$axios.get('/api/v1/admin/whoami'),
      ])
      this.enabled = setting.data.enabled
      this.allowedIps = ips.data
      this.currentIp = whoami.data.ip
    },
    async onToggleMaintenance(val) {
      if (val) {
        const inList = this.allowedIps.some(ip => ip.ip_address === this.currentIp)
        if (!inList) {
          const ok = window.confirm(
            `あなたの現在のIP (${this.currentIp}) が許可リストに登録されていません。\n` +
            `このままメンテナンスモードをONにすると、あなたも管理画面以外にアクセスできなくなります。\n\n` +
            `続行しますか?`
          )
          if (!ok) {
            this.enabled = false
            return
          }
        }
      }
      await this.$axios.patch('/api/v1/admin/maintenance', { maintenance: { enabled: val } })
      this.$toasted.global.success({ message: val ? 'メンテナンスモードをONにしました' : 'メンテナンスモードをOFFにしました' })
    },
    async createIp() {
      if (!this.newIp.ip_address) return
      try {
        await this.$axios.post('/api/v1/admin/maintenance_allowed_ips', { maintenance_allowed_ip: this.newIp })
        this.newIp = { ip_address: '', label: '' }
        await this.loadAll()
      } catch (e) {
        this.$toasted.global.error({ message: e.response?.data?.errors?.join(', ') || '追加に失敗しました' })
      }
    },
    async removeIp(id) {
      if (!window.confirm('削除しますか?')) return
      await this.$axios.delete(`/api/v1/admin/maintenance_allowed_ips/${id}`)
      await this.loadAll()
    },
    async addCurrentIp() {
      this.newIp = { ip_address: this.currentIp, label: '追加元: 管理者本人' }
      await this.createIp()
    },
  },
}
</script>
